import { motion } from "framer-motion";

const LoadingMini = ({percentaage}) => {
  const ContainerVariants = {
    animate: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const DotVariants = {
    animate: {
      y: ["0%", "100%"],
    },
  };

  const DotTransition = {
    duration: 0.5,
    repeat: Infinity,
    repeatType: "reverse",
    ease: "easeInOut",
  };

  return (

    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <motion.div
        className={`w-[5rem] h-[2rem] flex justify-around `}
        variants={ContainerVariants}
        animate="animate"
      >
        <motion.span
          className={`block w-4 h-4 bg-yellow-600 rounded-[50%]`}
          variants={DotVariants}
          transition={DotTransition}
        />
        <motion.span
          className={`block w-4 h-4 bg-yellow-600 rounded-[50%]`}
          variants={DotVariants}
          transition={DotTransition}
        />
        <motion.span
          className={`block w-4 h-4 bg-yellow-600 rounded-[50%]`}
          variants={DotVariants}
          transition={DotTransition}
        />
     <span className="hidden">{percentaage}</span>
      </motion.div>
    </div>

  );
};

export default LoadingMini;
